/* eslint-disable */

import {
  Card,
  Theme,
  createStyles,
  withStyles,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Paper,
  Tooltip,
  TableBody,
  Checkbox,
  AppBar,
  Toolbar,
  ButtonGroup,
  IconButton,
  Grid,
  FormControlLabel
} from "@material-ui/core";
import { show } from "redux-modal";
import { Component } from "react";
import SaveIcon from "@material-ui/icons/Save";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import SelectAllButton from "../../components/ConfigQuestionnaire/SelectAllButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  getSpecificQuestionnaire,
  putSpecificQuestionnaire,
} from "../../utils/store/actions/survey.action";
import Loader from "react-loader-spinner";

const styles = (theme: Theme) =>
  createStyles({
    input: {
      "&:focus": {
        outline: "none !important",
        border: "1px solid red",
      },
    },
    fundCards: {
      borderRadius: "12px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
    },
    backPageComponent: {
      display: "flex",
      alignItems: "center",
      margin: "1%",
    },
    backButton: {
      borderRadius: "5px",
      backgroundColor: "white",
      margin: "1%",
    },
    backInput: {
      marginLeft: "3%",
      display: "flex",
      alignItems: "center",
      fontSize: "20px",
      color: "black",
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
    tabList: {
      borderBottom: "2px solid #4b0084",
      boxSizing: "border-box",
      marginLeft: "20px",
      width: "100%",
      marginRight: "5%",
    },
    signersComponent: {
      display: "flex",
      width: "30%",
      flexDirection: "column",
    },
    savePart: {
      color: "white",
      textTransform: "none",
      backgroundColor: "#ae0064",
      width: "98%",
      margin: "0.5%",
      position: "sticky",
      bottom: 0,
      boxShadow:
        "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
    },
  });
const sortQuestions = (
  q1: { questionOrder: Number },
  q2: { questionOrder: Number }
) => {
  if (q1.questionOrder && q2.questionOrder) {
    if (q1.questionOrder > q2.questionOrder) return 1;
    if (q1.questionOrder < q2.questionOrder) return -1;
  }

  return 0;
};
const sortSections = (
  s1: { sectionOrder: Number },
  s2: { sectionOrder: Number }
) => {
  if (s1.sectionOrder && s2.sectionOrder) {
    if (s1.sectionOrder > s2.sectionOrder) return 1;
    if (s1.sectionOrder < s2.sectionOrder) return -1;
  }

  return 0;
};
class PartSpecificQuestionnaire extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showConfiguredOnly: true,
    };
  }
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  partId = this.urlParams.get("partId");
  listOfQuestions: any = [];

  handleChange = (event: any, value?: boolean) => {
    const sections = this.props.Surveys?.specificStructure;
    const id = event.target.id.split("_").slice(1).join("_");
    const params = event.target.id.split("_")[0];
    sections.forEach((sec: any, i: any) => {
      sec.subSection.forEach((sub: any) => {
        if (sub.questions !== []) {
          if (
            sub.questions.find((q: any) => {
              return q.id === id;
            })
          ) {
            if (typeof value !== undefined) {
              sub.questions.find((q: any) => {
                return q.id === id;
              })[params] = value;
            } else {
              sub.questions.find((q: any) => {
                return q.id === id;
              })[params] = !sub.questions.find((q: any) => {
                return q.id === id;
              })[params];
            }
            if (
              this.listOfQuestions.find(
                (question: any) => question.questionId === id
              )
            ) {
              this.listOfQuestions.find(
                (question: any) => question.questionId === id
              )[params] =
                typeof value !== undefined
                  ? value
                  : !sub.questions.find((q: any) => {
                      return q.id === id;
                    })[params];
            } else {
              const question: any = {
                questionId: id,
                partId: this.partId,
                [params]:
                  typeof value !== undefined
                    ? value
                    : !sub.questions.find((q: any) => {
                        return q.id === id;
                      })[params],
              };
              this.listOfQuestions.push(question);
            }
            this.setState({ ...this.state, checked: this.listOfQuestions });
          }
        }
      });
    });
  };

  selectAll = (id: any, visibleType: string): any => {
    // find all fields in section
    let array: any = [];
    this.props.Surveys?.specificStructure?.forEach((structure: any) => {
      const tempArray = structure.subSection.filter(
        (section: any) => section.id === id
      );
      if (tempArray.length > 0) {
        array = tempArray;
      }
    });

    if (array[0].questions) {
      const allFieldsVisible = array[0].questions.every(
        (question: any) => question[visibleType]
      );

      array[0].questions.forEach((question: any) => {
        const event = {
          target: {
            id: `${visibleType}_${question.id}`,
          },
        };
        this.handleChange(event, !allFieldsVisible);
      });
    }
  };
  handleSave = () => {
    this.props.putSpecificQuestionnaire(this.state.checked, this.partId);
    
  };

  toggleShowConfiguredOnly = () => {
    const showConfiguredOnly = !this.state.showConfiguredOnly;
    this.setState({ ...this.state, showConfiguredOnly });
  };
  render() {
    const { t } = this.props;
    const { classes } = this.props;
    return (
      <>
        <div style={{ margin: "1%", fontWeight: "bolder" }}>
          {t("SPECIFIC_QUESTIONNAIRE")}
        </div>
        <Card className={classes.card}>
          <AppBar
            className={classes.searchBar}
            position="static"
            color="default"
            elevation={0}
          >
            <Toolbar>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <ButtonGroup
                    variant="text"
                    color="primary"
                    aria-label="text primary button group"
                  >
                    <Tooltip title="Save config" placement="top">
                      <IconButton
                        aria-label="save"
                        style={{ backgroundColor: "#F5F6FF" }}
                        onClick={() => {
                          this.handleSave();
                        }}
                      >
                        <SaveIcon />
                      </IconButton>
                    </Tooltip>
                  </ButtonGroup>
                  <FormControlLabel
                        control={
                          <Checkbox
                            onChange={this.toggleShowConfiguredOnly}
                            id={`show-configured-questions-only`}
                            checked={this.state.showConfiguredOnly}
                            inputProps={{
                              "aria-label": "primary checkbox",
                            }}
                            
                          />
                        }
                        label='Show configured question only'
                      />
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          {this.props.Surveys?.specificStructure ? 
            this.props.Surveys?.specificStructure?.filter((sec: any) => ["subscription", "document"].includes(sec.name))
            .map((sec: any) => (
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} id={sec.id}>
                  {t(`distributor:${sec.label}`)}
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell align="right">
                            {t("visibleOperator")}
                          </TableCell>
                          <TableCell align="right">
                            {t("visibleInvestor")}
                          </TableCell>
                          <TableCell align="right">
                            {t("visibleDistributor")}
                          </TableCell>
                          <TableCell align="right">{t("mandatory")}</TableCell>
                          <TableCell align="right">
                            <Tooltip title={t("visibleEvenIfOwnerExternal")}>
                              <span>{t("visibleOwnerExternal")}</span>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sec.questions.length
                          ? sec?.questions.sort(sortQuestions).map((q: any) => (
                              <TableRow>
                                <TableCell component="th" scope="row">
                                  <>
                                    [{q.key}] {t(q.label)}
                                    {q.personType && (
                                      <small>({t(q.personType)})</small>
                                    )}
                                  </>
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleOperator_${q.id}`}
                                    checked={q.visibleOperator}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleInvestor_${q.id}`}
                                    checked={q.visibleInvestor}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleDistributor_${q.id}`}
                                    checked={q.visibleDistributor}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`mandatory_${q.id}`}
                                    checked={q.mandatory}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleOwnerExternal${q.id}`}
                                    checked={q.visibleOwnerExternal}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))
                          : sec.subSection
                              .filter((sub: any) => sec.name !== "document" || ["subscription", "person", "relation"].includes(sub.name))
                              .sort(sortSections)
                              .map((sub: any) => (
                                <>
                                  <TableRow
                                    style={{ backgroundColor: "lightgrey" }}
                                  >
                                    <TableCell component="th" scope="row">
                                      {t(`distributor:${sub.label}`)}
                                    </TableCell>
                                    {[
                                      "visibleOperator",
                                      "visibleInvestor",
                                      "visibleDistributor",
                                      "mandatory",
                                      "visibleOwnerExternal",
                                    ].map((visible: string) => {
                                      return (
                                        <TableCell size="small" align="right">
                                          <SelectAllButton
                                            onClick={() => {
                                              this.selectAll(sub.id, visible);
                                            }}
                                          />
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                  {sub?.questions
                                    .filter(q => (!this.state.showConfiguredOnly) || q.visibleOperator|| q.visibleInvestor || q.visibleDistributor)
                                    .sort(sortQuestions)
                                    .map((q: any) => (
                                      <TableRow
                                        style={{
                                          backgroundColor: `${
                                            q.type === "TITLE" && "#C7A3D1"
                                          }`,
                                        }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {q.type === "TITLE" ? (
                                            <Tooltip
                                              title={t("TITLE_OF_QUESTION")}
                                            >
                                              <strong>[{q.key}] {t(q.label)} **</strong>
                                            </Tooltip>
                                          ) : (
                                            <>
                                              [{q.key}] {t(q.label)}
                                              {q.personType && (
                                                <small>
                                                  ({t(q.personType)})
                                                </small>
                                              )}
                                            </>
                                          )}
                                        </TableCell>
                                        <TableCell size="small" align="right">
                                          <Checkbox
                                            onChange={this.handleChange}
                                            id={`visibleOperator_${q.id}`}
                                            checked={q.visibleOperator}
                                            inputProps={{
                                              "aria-label": "primary checkbox",
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell size="small" align="right">
                                          <Checkbox
                                            onChange={this.handleChange}
                                            id={`visibleInvestor_${q.id}`}
                                            checked={q.visibleInvestor}
                                            inputProps={{
                                              "aria-label": "primary checkbox",
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell size="small" align="right">
                                          <Checkbox
                                            onChange={this.handleChange}
                                            id={`visibleDistributor_${q.id}`}
                                            checked={q.visibleDistributor}
                                            inputProps={{
                                              "aria-label": "primary checkbox",
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell size="small" align="right">
                                          <Checkbox
                                            onChange={this.handleChange}
                                            id={`mandatory_${q.id}`}
                                            checked={q.mandatory}
                                            inputProps={{
                                              "aria-label": "primary checkbox",
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell size="small" align="right">
                                          <Checkbox
                                            onChange={this.handleChange}
                                            id={`visibleOwnerExternal_${q.id}`}
                                            checked={q.visibleOwnerExternal}
                                            inputProps={{
                                              "aria-label": "primary checkbox",
                                            }}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </>
                              ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            )) : 
            (
              <Paper>
                <Loader
                  type="ThreeDots"
                  color="#4B0084"
                  height={50}
                  width={100}
                  timeout={3000} //3 secs
                />
              </Paper>
            )
            }
        </Card>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getSpecificQuestionnaire,
  putSpecificQuestionnaire,
  show,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartSpecificQuestionnaire)));
